/* eslint-disable */
import firebase from 'firebase/app';
require('firebase/auth')
import 'firebase/firestore'
const config = require("./keys/key.json")
// firebase init goes here
firebase.initializeApp(config.firebase)



// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()
const googleProvider = new firebase.auth.GoogleAuthProvider();
const currentUser = auth.currentUser


// date issue fix according to firebase
const settings = {

}
db.settings(settings)


firebase.firestore().enablePersistence()
    .catch(function (err) {
        console.error(err)
        if (err.code == 'failed-precondition') {
            // Multiple tabs open, persistence can only be enabled
            // in one tab at a a time.
            // ...
        } else if (err.code == 'unimplemented') {
            // The current browser does nvot support all of the
            // features required to enable persistence
            // ...
        }
    });

// firebase collections
const usersCollection = db.collection('users')
const playersCollection = db.collection('players')
export {
    db,
    googleProvider,
    auth,
    currentUser,
    usersCollection,
    playersCollection,
    config
}